// Kept apart from CatalogPage: the route's validateSearch needs isCatalogTab
// eagerly, and importing it from CatalogPage would pull the whole page into the
// public entry chunk (scripts/route-code-split-plugin.ts).
export type CatalogTab = "services" | "tests";

export const CATALOG_TABS: Array<{ value: CatalogTab; label: string }> = [
  { value: "services", label: "Usluge" },
  { value: "tests", label: "Testovi" },
];

export function isCatalogTab(value: unknown): value is CatalogTab {
  return typeof value === "string" && CATALOG_TABS.some((t) => t.value === value);
}
